import { NgModule } from '@angular/core';

import { ViewCacheOperationDirective } from './view-cache-operation.directive';

@NgModule({
    declarations: [
        ViewCacheOperationDirective
    ],
    exports: [
        ViewCacheOperationDirective
    ]
})
export class ViewCacheOperationModule { }